import React, { Component } from 'react';
import PreLoaderWidget from '../../../components/Loader';
import Notificacao from '../../../components/Notificacao';
import Loading from '../../../components/Loading';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { Editor } from "@tinymce/tinymce-react";
import ReactHtmlParser from "react-html-parser";
import ImageView from '../../../gb-components/ImageView';
import { getLoggedInUser } from '../../../helpers/authUtils';
import ConfirmModal from '../../../gb-components/ConfirmModal';
import {
  firebaseFire as Libfirebase,
} from "../../../helpers/firebase-config";
import { AuditoriaStatus } from '../../../helpers/enums';


export default class ComentarAuditoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      comentarios: [],
      comentario: "",
      midias: [],
      user: getLoggedInUser(),
      finishModal: false
    };

    this._setComentario = this._setComentario.bind(this);
    this._finishAuditoria = this._finishAuditoria.bind(this);
  }

  componentDidMount() {
    // console.log(this.state.user)
    this.setState({
      comentarios: this.props.auditoria.comentarios ? this.props.auditoria.comentarios : [],
      midias: this.props.auditoria.outrosAnexos.map((a, i) => {
        return {
          src: a,
          name: `Anexo ${i + 1}`
        }
      })
    })
  }

  _setComentario = async (e) => {
    this.setState({ loading: true });
    const {
      comentario,
      comentarios
    } = this.state;

    // const user = firebaseAuth.currentUser;

    //valida os campos

    let erros = []
    if (!comentario || comentario === "") {
      erros.push("Descreva um comentário!")
    }

    if (erros.length > 0) {
      this.setState({
        loading: false,
        notifition: true,
        msg: erros.join("<br />"),
        nameclass: 'alert-danger'
      });
      return;
    }

    const commentAux = [
      ...comentarios,
      {
        comentario: comentario,
        profissionalRef: this.state.user.ref,
        profissional: this.state.user.username,
        created_at: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    ]
    const status = AuditoriaStatus.Comentado
    this.props.auditoria.ref.update({
      status: status,
      updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      comentarios: commentAux
    })

    // console.log("aqui --", this.props.auditoria.ref.parent.parent.id)
    await Libfirebase.collection("paciente")
      .doc(this.props.auditoria.ref.parent.parent.id)
      .update({
        'status_auditoria_material': status,
        // 'status': "Pendências" // serve para aparecer no sino da home
      })

    this.props.getAuditoriasData()
    this.setState({ comentarios: commentAux, loading: false })
  };

  async _finishAuditoria() {
    const status = AuditoriaStatus.Finalizado

    await this.props.auditoria.ref.update({
      status: status,
      updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      profissional_finalizou: this.state.user.ref,
    })

    await Libfirebase.collection("paciente")
      .doc(this.props.auditoria.ref.parent.parent.id)
      .update({ 'status_auditoria_material': status })

    this.close()
  }

  close() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <div className="p-3">
        <ConfirmModal
          open={this.state.finishModal}
          message={`Deseja realmente finalizar esta solicitação de auditoria? Não será mais possível comentar!`}
          cancelButtonAction={() => { this.setState({ finishModal: false }) }}
          confirmButtonAction={this._finishAuditoria}
        />

        <Loading loading={this.state.loading} />

        {this.state.notifition ? (
          <Notificacao
            msg={this.state.msg}
            nameclass={this.state.nameclass}
          />
        ) : null}

        <Row>
          <Col md={12}>
            {this.props.auditoria.status === AuditoriaStatus.Finalizado &&
              <Row>
                <Col md={6}>
                  <h4>Data da finalização: {moment(this.props.auditoria.updated_at).format('DD/MM/YYYY HH:mm:ss')}</h4>
                </Col>
                <Col md={6}>
                  <h4>Finalizado por: {this.props.auditoria.usuarioFinalizou}</h4>
                </Col>
              </Row>
            }

            <Row>
              <Col md={6}>
                <h4>Descrição da solicitação</h4>
              </Col>
              <Col md={6}>
                {this.props.auditoria.status !== AuditoriaStatus.Finalizado &&
                  <button
                    style={{ float: 'right' }}
                    type="button"
                    className="btn gb-button"
                    onClick={() => this.setState({ finishModal: true })}
                  >
                    Finalizar Solicitação
                  </button>
                }

              </Col>
            </Row>
            <p>{ReactHtmlParser(this.props.auditoria.descricao)}</p>
            <Row className='mb-3'>
              <Col md={3}>
                <p>Receita</p>
                <ImageView
                  midias={[{ src: this.props.auditoria.receita }]}
                  edit={false}
                  width={60}
                  height={60}
                />
              </Col>
              <Col md={9}>
                <p>Arquivos em anexo</p>
                <ImageView
                  midias={this.state.midias}
                  edit={false}
                  width={60}
                  height={60}
                />
              </Col>
            </Row>
            {this.state.comentarios.map((c, i) => {
              return (
                <div key={i} className={"gb-card mb-3"}>
                  <div className={this.state.user.username === c.profissional ? "gb-card-header profissional" : "gb-card-header"}>
                    <p>{c.profissional}</p>
                    <div style={{ textAlign: this.state.user.username === c.profissional ? 'right' : null, }}>
                      {c.created_at ? (
                        <span className="gb-card-header-hora">
                          {moment(c.created_at).format('DD/MM/YYYY HH:mm:ss')}
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="gb-card-body">
                    {ReactHtmlParser(c.comentario)}
                  </div>

                </div>
              )
            })}
            {this.props.auditoria.status !== AuditoriaStatus.Finalizado &&
              <React.Fragment>
                <hr></hr>
                <h4>Responda abaixo sobre a solicitação deste material</h4>
                <Editor
                  onEditorChange={e => this.setState({ comentario: e })}
                  value={this.state.comentario}
                  apiKey="jl2uw5yob5e4avhldqg1sm0npw0zkdayoz2xj4wwgr2lj1ei"
                  init={{
                    language: 'pt_BR',
                    height: 250,
                    placeholder: "Descreva uma resposta para a solicitação",
                    toolbar: "undo redo | fontselect fontsizeselect | bold italic underline forecolor backcolor | align lineheight checklist bullist numlist",
                    browser_spellcheck: true,
                  }}
                ></Editor>
              </React.Fragment>
            }

          </Col>
        </Row>

        {this.props.auditoria.status !== AuditoriaStatus.Finalizado &&
          <div className="mt-3">
            {
              this.state.loading ?
                (<PreLoaderWidget></PreLoaderWidget>) :
                <button
                  style={{ float: 'right', marginTop: '10px' }}
                  type="button"
                  className="btn gb-button"
                  disabled={this.state.loading}
                  onClick={() => this._setComentario()}
                >
                  Comentar
                </button>
            }

          </div>
        }


      </div>
    );
  }
}
